<template>
	<div>
		<div class="btLine"></div>
		<div class="btm">
			<div>Join Our Community</div>
			<img @click="() => clk('https://twitter.com/0xSingularLabs')" :src="MyImage.home.twiter" class="icon" alt="">
			<img @click="() => clk('https://discord.com/invite/63n4MW4Y7a')" :src="MyImage.home.tw1" class="icon" alt="">
			<img @click="() => clk('https://medium.com/@singularlabs')" :src="MyImage.home.tw2" class="icon" alt="">
		</div>
	</div>
</template>
<script setup lang="ts">
import { MyImage } from '@icon/MyImage';

const clk = (url: string) => {
	window.open(url, '_blank')
}
</script>

<style scoped>
.btLine {
	height: 1px;
	background: linear-gradient(90deg, rgba(187, 242, 71, 0) 0%, rgba(14, 235, 170, 0.3) 43.75%, rgba(187, 242, 71, 0) 100%);
}

.btm {
	margin: 0 var(--dimApp) 10px;
	display: flex;
	align-items: center;
	color: white;
	padding: 30px 40px;
}

.icon {
	margin-left: 30px;
	cursor: pointer;
}
</style>